import { getSharedRootStore } from '@bringg-frontend/global-stores';

export const isWayPointTimeZoneEnabled = () => {
	const {
		data: { merchantConfigurationsStore }
	} = getSharedRootStore();

	return (
		merchantConfigurationsStore.localizeTaskTimezonesByTeams && merchantConfigurationsStore.enableWaypointTimezone
	);
};
